const SgiFormDateEO = function () {
    return {
        alwBlk: true,
        // c:"desId",
        ctlH: 0,
        ctlN: "日期控件",
        ctlW: 24,
        // dateFmt:"YYYY-MM-DD", // 日期格式 HH:mm:ss
        // dateTimeFlag: false, // 是否显示时间
        desId: "EP_EO_UI_3106",
        isDis: false,
        isHdn: false,
        lblW: 6,
        te: "日期",

        isLbl: false,
        lblAlg: "right",
        ctlMode: "date",//默认模式：日期模式
        inpPopTe: "请选择日期",
        // csstyle:"date-default", // 显示样式
        // disDays:"0", // 禁止选择星期
        // isRead:false,
        // optBDt:moment("2018-02-01", 'YYYY-MM-DD'), // 可选的起始日期
        // optEDt:moment("2018-05-01", 'YYYY-MM-DD'), // 可选的结束日期
        // msfTgt:"qtip",

        // isGw:false, //延伸状态
        // isSrp:true, //键盘过滤状态
        // maxL:20,
        // minL:0,
        // n:"描述GUID",
        // sNo:10,
        // t:"date",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormDateEO };
export default SgiFormDateEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormDateEO.js